module.exports = __webpack_public_path__ + "static/img/NP.878559b4.jpg";